export enum TipoSituacaoEnum {
  Rascunho = 1,
  EmAnalise = 2,
  Aprovado = 3,
  Reprovado = 4,
  Simulado = 5,
  Vigente = 6,
  Oficial = 7,
  Descartado = 8
}
